import React from 'react';
import { ChefHat, RefreshCw } from 'lucide-react';

export default function CocinaHeader({
  pendientes,
  enPreparacion,
  listos,
  onRefresh,
  cargando,
}) {
  return (
    <div className="rounded-2xl bg-gradient-to-r from-azul-oscuro to-verde-esmeralda p-5 text-white shadow-lg sm:p-6">
      <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-4">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white/15">
            <ChefHat size={27} />
          </div>

          <div>
            <p className="text-sm font-semibold text-white/70">
              Driza Camp · Restaurante
            </p>

            <h1 className="text-2xl font-bold sm:text-3xl">
              Cocina
            </h1>

            <p className="mt-1 text-sm text-white/75">
              Pedidos listos para preparar y entregar.
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <div className="rounded-xl bg-white/10 px-4 py-3 text-center">
            <div className="text-xl font-black">{pendientes}</div>
            <div className="text-xs font-semibold text-white/70">
              Pendientes
            </div>
          </div>

          <div className="rounded-xl bg-white/10 px-4 py-3 text-center">
            <div className="text-xl font-black">{enPreparacion}</div>
            <div className="text-xs font-semibold text-white/70">
              Preparando
            </div>
          </div>

          <div className="rounded-xl bg-white/10 px-4 py-3 text-center">
            <div className="text-xl font-black">{listos}</div>
            <div className="text-xs font-semibold text-white/70">
              Listos
            </div>
          </div>

          <button
            type="button"
            onClick={onRefresh}
            disabled={cargando}
            className="flex h-11 items-center gap-2 rounded-xl bg-white px-4 text-sm font-bold text-azul-oscuro shadow-sm transition hover:brightness-105 disabled:opacity-60"
          >
            <RefreshCw
              size={17}
              className={cargando ? 'animate-spin' : ''}
            />
            Actualizar
          </button>
        </div>
      </div>
    </div>
  );
}
